export default "__VITE_ASSET__748a4158__"